<div class="page-container">
    <div class="background-container">
        <div class="header-container">
            <div class="text-container">
                <h1 class="title-text">Invite friends to Premium and earn free rewards</h1>
                <p class="message-text">Invite a Friend incentives are exclusively available on the cloudigo application only. Kindly visit the cloudigo app to participate and earn rewards.</p>
            </div>
            <img class="baf-image" src="/old/friends/baf-generic-image.webp" alt="Bring a Friend Rewards"/>
        </div>
    </div>
    <div class="content-container">
        <div class="button-container">
            <a mat-flat-button class="button-action" [routerLink]="['/b', 'baf-info']">OPEN APP</a>
            <a mat-stroked-button class="button-action" [routerLink]="meta.platform.IOS ? ['/ios'] : ['/android']">DOWNLOAD APP</a>
        </div>
        <div class="instructions-container">
            <h2 class="instructions-title-text">How to invite friends</h2>
            <div class="instructions-row">
                <div class="instruction-step">
                    <div class="instruction-step-index">
                        <p class="instruction-step-value">1</p>
                    </div>
                    <div class="instruction-step-design"></div>
                </div>
                <div class="instruction-info">
                    <h4 class="instruction-info-title-text">Open/Download app</h4>
                    <p class="instruction-info-text">Open or download the free cloudigo application.</p>
                </div>
            </div>
            <div class="instructions-row">
                <div class="instruction-step">
                    <div class="instruction-step-index">
                        <p class="instruction-step-value">2</p>
                    </div>
                    <div class="instruction-step-design"></div>
                </div>
                <div class="instruction-info">
                    <h4 class="instruction-info-title-text">Visit Profile Section</h4>
                    <p class="instruction-info-text">Click on the Profile icon on the top right of the homepage and select ‘Invite a Friend’</p>
                </div>
            </div>
            <div class="instructions-row">
                <div class="instruction-step">
                    <div class="instruction-step-index-selected">
                        <p class="instruction-step-value">3</p>
                    </div>
                </div>
                <div class="instruction-info">
                    <h4 class="instruction-info-title-text">Participate & Earn Rewards</h4>
                    <p class="instruction-info-text">Check the latest available ‘Invite a Friend’ campaigns and start inviting friends!</p>
                </div>
            </div>
        </div>
    </div>
</div>